import { useEffect, RefObject } from 'react';
import { useSelector } from 'react-redux';

const useScrollToPlans = (paymentPlansRef: RefObject<HTMLDivElement>) => {
  const referer = useSelector((state: any) => state.app.referer);

  useEffect(() => {
    if (referer.includes('real-estate-offers') && paymentPlansRef.current) {
      const plansPosition =
        paymentPlansRef.current.getBoundingClientRect().top - 220;

      window.scrollTo({
        top: plansPosition,
        behavior: 'smooth'
      });
    }
  }, [referer, paymentPlansRef]);
};

export default useScrollToPlans;
